export function startCategoryFilters() {
    const filters = document.querySelector('[data-product-filters]');
    if (!filters) {
        return;
    }

    const articles = document.querySelectorAll('#category .products article[data-product-type]');
    const buttons = filters.querySelectorAll('[data-filter]');
    let activeFilter = null;

    function applyFilter(filter) {
        activeFilter = filter;

        buttons.forEach((button) => {
            const isActive = button.dataset.filter === filter;
            button.classList.toggle('active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        articles.forEach((article) => {
            if (!filter) {
                article.hidden = false;
                return;
            }

            article.hidden = article.dataset.productType !== filter;
        });
    }

    buttons.forEach((button) => {
        button.setAttribute('aria-pressed', 'false');

        button.addEventListener('click', () => {
            const { filter } = button.dataset;
            applyFilter(activeFilter === filter ? null : filter);
        });
    });

    applyFilter(null);
}
